import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa'

const CallToAction = () => {
  return (
    <section className="py-24 relative bg-white">
      <div className="container-custom">
        <div className="bg-secondary-900 rounded-[3rem] relative p-8 md:p-12 lg:p-16 shadow-2xl flex flex-col lg:flex-row items-center gap-12 overflow-hidden">

          {/* Abstract decorative shapes inside the card */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500 opacity-20 blur-3xl rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-accent-500 opacity-20 blur-3xl rounded-full -translate-x-1/2 translate-y-1/2 pointer-events-none"></div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="lg:w-1/2 relative z-10 space-y-8"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-tight">
              Ready to Upgrade<br /> Your <span className="text-primary-400 drop-shadow-md">Lifestyle?</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-300 font-light max-w-lg">
              Join a vibrant community of independent women. Stop compromising and start living in a place that truly feels like home.
            </p>

            <ul className="space-y-4">
              {['Zero Brokerage Fees', '100% Verified Properties', 'Dedicated Female Wardens'].map((item, idx) => (
                <li key={idx} className="flex items-center gap-3 text-white font-medium">
                  <FaCheckCircle className="text-primary-400 text-xl" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="pt-4">
              <Link
                to="/properties"
                className="bg-primary-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-primary-500 hover:shadow-glow hover:-translate-y-1 transition-all duration-300 inline-flex items-center gap-3"
              >
                Find Your New Home <FaArrowRight />
              </Link>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="lg:w-1/2 relative z-20 w-full flex justify-center lg:justify-end"
          >
            <div className="relative w-full max-w-md">
              <div className="relative rounded-[2rem] overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&q=80&w=800"
                  alt="Happy Residents"
                  className="w-full h-auto object-cover"
                />
                {/* Floating badge over image */}
                <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-xl px-4 py-3 rounded-2xl shadow-xl flex items-center gap-3 border border-gray-100">
                  <div className="bg-accent-100 p-2 rounded-xl">
                    <span className="text-accent-700 font-bold text-xl">4.9</span>
                  </div>
                  <div>
                    <div className="text-[10px] font-extrabold text-gray-500 uppercase tracking-widest">Average Rating</div>
                    <div className="text-secondary-900 font-bold text-sm">from 5k+ women</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  )
}

export default CallToAction
